<template>
    <div class="autoView" :class="[mode, { noIPXBar }]">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'autoView',
    props: {
        header: {
            type: Boolean,
            default: true,
        },
        footer: {
            type: Boolean,
            default: false,
        },
        noIPXBar: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mode () {
            if ( this.header && this.footer ) return 'normal';
            if ( this.header ) return 'only-header';
            if ( this.footer ) return 'only-footer';
            return 'full-screen';
        },
    },
};
</script>

<style lang="scss" scoped>
.autoView {
    position: relative;
    overflow: hidden auto;
    height: calc(var(--app-height) - var(--safe-top) - var(--nav-content-height, 44px) - var(--footer-height, var(--nav-content-height, 44px)) - var(--safe-bottom));

    &.only-header {
        height: calc(var(--app-height) - var(--safe-top) - var(--nav-content-height, 44px));
    }

    &.only-footer {
        height: calc(var(--app-height) - var(--footer-height, var(--nav-content-height, 44px)) - var(--safe-bottom));
    }

    &.full-screen {
        height: calc(var(--app-height) - var(--safe-bottom));

        &.noIPXBar {
            height: var(--app-height);
        }
    }
}
</style>
